<template>
	<section id="detail-list">
		<table class="screen-only">
			<thead>
				<tr>
					<th>
						<span class="sr-only">
							{{ $t('labels.save_to_list') }}
						</span>
					</th>
					<th v-for="(header, i) in colHeaders" v-bind:key="i" class="h6">
						{{ header }}
					</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="r in results" v-bind:key="r.id" @click="goTo(r, $event)">
					<td class="save-input">
						<button
							class="unsave-btn btn"
							type="button"
							@click="updateSave({id: r.id, checkLimit: false}, $event)"
							v-if="showBookmark(r.id)"
						>
							<span class="bookmark btn">
								<svg class="btn" xmlns="http://www.w3.org/2000/svg" width="20" height="28" viewBox="0 0 20 28" fill="none">
									<path class="btn" fill-rule="evenodd" clip-rule="evenodd" d="M0 0V28L9.91852 20.4479L19.8333 28V0H0Z" fill="#93DA72"/>
								</svg>
							</span>
						</button>
						<button
							v-else
							class="save-btn"
							type="button"
							@click="updateSelection({id: r.id, type: 'saved'}, $event)"
						>
							<span
								class="save-btn icon-checkbox"
								:class="{ saved: isSelected(r.id) }"
								aria-hidden="true">
							</span>
							<span class="sr-only" v-if="isSelected(r.id)"
								>{{ $t('labels.save_to_list') }}
							</span>
							<span class="sr-only" v-else
								>{{ $t('labels.remove_from_list') }}
							</span>
						</button>
					</td>
					<td class="image-cell">
						<figure class="media-image">
							<img
								v-if="displayImg(r)"
								:src="displayImg(r)"
								:alt="displayTitle(r)"
							>
							<div class="media-type" v-else-if="displayMedia(r)">
								<p>
									{{ displayMedia(r) }}
								</p>
							</div>
							<img
								v-else
								src="../assets/images/icon-missing-image.svg"
								:alt="displayTitle(r)"
							>
						</figure>
					</td>
					<td
						class="number row-text"
						:class="{ hide: displayControlNo(r) == '—' }"
					>
						{{ displayControlNo(r) }}
					</td>
					<td class="title row-text" :class="{ hide: displayTitle(r) == '—' }">
						<router-link
							:to="{ name: `${r.type}-detail`, params: { id: r.id } }"
						>
							{{ displayTitle(r) }}
						</router-link>
					</td>
					<td
						class="person row-text"
						:class="{ hide: displayPerson(r) == '—' }"
					>
						<span v-html="displayPerson(r)"></span>
					</td>
					<td
						v-if="showService"
						class="service row-text"
						:class="{ hide: displayService(r) == '—' }"
					>
						{{ displayService(r) }}
					</td>
					<td class="row-text" :class="{ hide: displayDate(r) == '—' }">
						{{ displayDate(r) }}
					</td>
					<td
						class="call-num row-text"
						:class="{ hide: displayCallNo(r) == '—' }"
					>
						{{ displayCallNo(r) }}
					</td>
				</tr>
			</tbody>
		</table>
		<table class="to-print" aria-hidden="true">
			<thead>
				<tr>
					<th>
					</th>
					<th v-for="(header, i) in colHeaders" v-bind:key="i" class="h6">
						{{ header }}
					</th>
				</tr>
			</thead>

			<tbody>
				<tr v-for="r in allResults" v-bind:key="r.id" @click="goTo(r, $event)">
					<td class="save-input">
					</td>
					<td class="image-cell">
						<figure class="media-image">
							<img
								v-if="displayImg(r)"
								:src="displayImg(r)"
								:alt="displayTitle(r)"
							>
							<div class="media-type" v-else-if="displayMedia(r)">
								<p>
									{{ displayMedia(r) }}
								</p>
							</div>
							<img
								v-else
								src="../assets/images/icon-missing-image.svg"
								:alt="displayTitle(r)"
							>
						</figure>
					</td>
					<td
						class="number row-text"
						:class="{ hide: displayControlNo(r) == '—' }"
					>
						{{ displayControlNo(r) }}
					</td>
					<td class="title row-text" :class="{ hide: displayTitle(r) == '—' }">
						<a :href="pdfLink(r)">
							{{ displayTitle(r) }}
						</a>
					</td>
					<td
						class="person row-text"
						:class="{ hide: displayPerson(r) == '—' }"
					>
						<span v-html="displayPerson(r)"></span>
					</td>
					<td
						v-if="showService"
						class="service row-text"
						:class="{ hide: displayService(r) == '—' }"
					>
						{{ displayService(r) }}
					</td>
					<td class="row-text" :class="{ hide: displayDate(r) == '—' }">
						{{ displayDate(r) }}
					</td>
					<td
						class="call-num row-text"
						:class="{ hide: displayCallNo(r) == '—' }"
					>
						{{ displayCallNo(r) }}
					</td>
				</tr>
			</tbody>
		</table>
	</section>
</template>

<script>
import { mapGetters } from "vuex";
import SavedListMixin from "../mixins/SavedListMixin";
import ResultsImageMixin from "../mixins/ResultsImageMixin";

export default {
	mixins: [SavedListMixin, ResultsImageMixin],
	props: {
		results: Array,
		viewType: {
			type: String,
			default: "saved"
		},
		allResults: Array
	},
	computed: {
		...mapGetters({
			query: "search/query",
			type: "search/type",
			site: "search/site",
		}),
		colHeaders() {
			let headers = this.$i18n.messages[this.$i18n.locale].results_fields_map[
				this.type
			];
			if (!this.showService) {
				let serviceInd = headers.findIndex((h) => {
					return h == "Service" || h == "Arme";
				});
				headers.splice(serviceInd, 1);
			}
			return headers;
		},
		showService() {
			return this.site == "cwm";
		},
	},
	methods: {
		showBookmark(id) {
			return this.isSaved(id) && this.viewType == 'shared';
		},
		goTo(r, e) {
			if (e.target.classList.contains("save-btn")) return;
			this.$router.push({ name: `${r.type}-detail`, params: { id: r.id } });
		},
		displayTitle(item) {
			return item.title;
		},
		displayPerson(item) {
			if (item.type == "artifact") {
				return item.artist_maker ? item.artist_maker.join("<br>") : "—";
			}
			if (item.type == "archive") {
				return item.names ? item.names.join(", ") : "—";
			}
		},
		displayDate(item) {
			if (item.type == "artifact") {
				return item.date_made || "—";
			}
			if (item.type == "archive") {
				return item.unit_dates ? item.unit_dates[0] : "—";
			}
		},
		displayCallNo(item) {
			return item.call_nums ? item.call_nums.join(", ") : "—";
		},
		displayControlNo(item) {
			if (item.type == "artifact") {
				return item.artifact_num || "—";
			} else {
				if (item.control_num) {
					return item.control_num[0];
				} else if (item.accession_num) {
					return Array.isArray(item.accession_num)
						? item.accession_num[0]
						: item.accession_num;
				} else {
					return "—";
				}
			}
		},
		displayService(item) {
			if (item.military) {
				return item.military.service ? item.military.service.join(", ") : "—";
			} else {
				return "—";
			}
		},
		pdfLink(item) {
			let path = this.$i18n.messages[this.$i18n.locale].main[this.site].cannonical;
			let itemPath = item.path
					.split("/")
					.splice(2, 2)
					.join("/");

			return `${path}/${itemPath}`
		}
	},
};
</script>

<style scoped lang="scss">
#detail-list {
	width: 100%;
}

table {
	border-spacing: 0;
	width: 100%;

	&.to-print {
		display: none;
	}
}
th.h6,
td {
	font-size: 0.875rem;
}

p,
a {
	color: $dark-gray1;
	margin: 0;
	text-decoration: none;
}
thead {
	th {
		padding: $s2 $s1;
		text-align: left;
		position: sticky;
		top: 80px;
		background: $white;
		z-index: 2;
	}
}
.saved-list{
	thead{
		th{
			background-color: $off-white;
		}
	}
	tbody{
		tr{
			background: rgba(255, 255, 255, 0.4);
			&:nth-child(odd) {
				background: rgba(255, 255, 255, 0.8);
			}
		}
	}
} 
tbody {
	tr {
		cursor: pointer;
		min-height: 200px;
		td {
			max-width: 400px;
			padding: $s2;

			&.image-cell {
				max-width: 130px;
				height: 100%;
			}

			.media-image {
				margin: 0;
				height: 100%;
				max-height: 160px;
				max-width: 210px;
				width: auto;
				overflow: hidden;

				display: flex;
				justify-content: center;
				align-items: center;

				img {
					height: 100%;
					width: 100%;
					object-fit: contain;
				}

				.media-type {
					font-family: "Futura";
					font-size: 1rem;
					color: $dark-gray2;
					text-transform: uppercase;
					opacity: 0.6;
					border: solid $dark-gray2 2px;
					border-radius: 50%;
					height: 34%;
					width: 34%;
					min-height: 60px;
					min-width: 60px;
					box-sizing: border-box;
					display: flex;
					justify-content: center;
					align-items: center;

					p {
						margin: 0;
					}
				}
			}

			span {
				line-height: 1.2rem;
			}
		}
		&:nth-child(odd) {
			background: $off-white;
			padding: $s1;
		}
	}
}
.bookmark{
	display: block;
	position: absolute;
	top: -6px;
	left: 10px;
	z-index: 2;
}
.save-input {
	position: relative;	
	button {
		border: none;
		background: none;
		cursor: pointer;
	}

	.icon-checkbox {
		border: solid 2px $menu-gray;
		display: inline-block;
		height: 18px;
		width: 18px;
		margin-right: 0.5rem;

		&.saved {
			border: $cwm-green 2px solid;
			background: $cwm-green;

			&:after {
				height: 18px;
				content: url("../assets/images/icon-check.svg");
				display: flex;
				justify-content: center;
				align-items: center;
			}
		}
	}
}

@media (max-width: $mq-max-width-desktop) {
	tbody tr td {
		padding: 1rem 0.5rem;
		font-size: 0.8rem;
	}
}

@media screen and (max-width: $mq-max-width-tablet) {
	#detail-list {
		thead th {
			display: none;
		}
		tbody {
			tr {
				display: grid;
				position: relative;
				grid-template-rows: auto auto auto 1fr;

				.save-input {
					position: absolute;
					top: 0;
					right: $side-padding-mobile;
					width: 20px;
				}

				.image-cell {
					width: 25%;
					max-width: unset;
					position: absolute;
					top: 0;
					left: $side-padding-mobile;

					img {
						padding-top: 0.5rem;
						object-position: top;
					}
				}

				td.row-text {
					margin-left: 35%;
					margin-right: $side-padding;
					padding: 0.5rem;

					&.hide {
						display: none;
					}
				}

				&:nth-child(even) {
					padding: $s1;
					background: $white;
				}
			}
		}
	}
}

@media print {
	#detail-list,
	table {
		width: 100%;
	}

	table {
		border-collapse: collapse;

		tr,
		tr:nth-child(odd) {
			background: $white;
			border-top: solid 1px $med-gray1;
		}

		&.to-print {
			display: block;
		}
		&.screen-only {
			display: none;
		}
	}

	thead {
		th {
			&:first-child {
				display: none;
			}
			&.h6 {
				position: relative;
				top: unset;
				font-size: 0.8rem;
				font-weight: normal;
				font-family: "Futura";
				padding: 0.8rem;
			}
		}
	}

	img {
		max-height: 100px;
	}

	tr td:first-child {
		display: none;
	}
}
</style>
